import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../App";

const LoginPage = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const result = await login(formData.username, formData.password);

    if (result.success) {
      navigate("/admin/dashboard");
    }

    setLoading(false);
  };

  return (
    <div
      className="login-page"
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
      }}
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-5">
            <div className="card shadow-lg border-0 animate__animated animate__fadeInUp">
              <div className="card-body p-5">
                <div className="text-center mb-4">
                  <img
                    src="https://www.i-pic.info/i/krVq1004512.jpg"
                    alt="Logo"
                    className="mb-3"
                    style={{
                      width: "100px",
                      height: "100px",
                      borderRadius: "50%",
                      boxShadow: "0 5px 15px rgba(0,0,0,0.2)",
                    }}
                  />
                  <h3 className="fw-bold text-primary">เข้าสู่ระบบผู้ดูแล</h3>
                  <p className="text-muted">ระบบลงนามถวายพระพรชัยมงคล</p>
                </div>

                <form onSubmit={handleSubmit}>
                  <div className="mb-4">
                    <label className="form-label">
                      <i className="fas fa-user me-2"></i>ชื่อผู้ใช้
                    </label>
                    <div className="input-group">
                      <span className="input-group-text bg-gradient-primary text-white">
                        <i className="fas fa-user"></i>
                      </span>
                      <input
                        type="text"
                        className="form-control form-control-lg"
                        name="username"
                        value={formData.username}
                        onChange={handleInputChange}
                        placeholder="กรอกชื่อผู้ใช้"
                        required
                        autoFocus
                      />
                    </div>
                  </div>

                  <div className="mb-4">
                    <label className="form-label">
                      <i className="fas fa-lock me-2"></i>รหัสผ่าน
                    </label>
                    <div className="input-group">
                      <span className="input-group-text bg-gradient-primary text-white">
                        <i className="fas fa-lock"></i>
                      </span>
                      <input
                        type={showPassword ? "text" : "password"}
                        className="form-control form-control-lg"
                        name="password"
                        value={formData.password}
                        onChange={handleInputChange}
                        placeholder="กรอกรหัสผ่าน"
                        required
                      />
                      <button
                        className="btn btn-outline-secondary"
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        <i
                          className={`fas fa-eye${
                            showPassword ? "-slash" : ""
                          }`}
                        ></i>
                      </button>
                    </div>
                  </div>

                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="remember"
                      />
                      <label className="form-check-label" htmlFor="remember">
                        จดจำการเข้าสู่ระบบ
                      </label>
                    </div>
                  </div>

                  <button
                    type="submit"
                    className="btn btn-gradient-primary btn-lg w-100 mb-3"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        กำลังเข้าสู่ระบบ...
                      </>
                    ) : (
                      <>
                        <i className="fas fa-sign-in-alt me-2"></i>
                        เข้าสู่ระบบ
                      </>
                    )}
                  </button>

                  <div className="text-center">
                    <a href="/" className="btn btn-link text-muted">
                      <i className="fas fa-arrow-left me-2"></i>
                      กลับหน้าหลัก
                    </a>
                  </div>
                </form>

                <hr className="my-4" />

                <div className="text-center text-muted small">
                  <p className="mb-0">
                    <i className="fas fa-info-circle me-1"></i>
                    สำหรับผู้ดูแลระบบเท่านั้น
                  </p>
                  <p className="mb-0">
                    หากต้องการลงนามถวายพระพร <a href="/">คลิกที่นี่</a>
                  </p>
                </div>
              </div>
            </div>

            <div className="text-center mt-4 text-white">
              <small>
                พัฒนาโดย {process.env.REACT_APP_ORGANIZATION} ©{" "}
                {new Date().getFullYear()}
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
